import { render, staticRenderFns } from "./PaymentPayerSettlement.vue?vue&type=template&id=0c8d26ff&scoped=true"
import script from "./PaymentPayerSettlement.vue?vue&type=script&lang=js"
export * from "./PaymentPayerSettlement.vue?vue&type=script&lang=js"
import style0 from "./PaymentPayerSettlement.vue?vue&type=style&index=0&id=0c8d26ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8d26ff",
  null
  
)

export default component.exports